<template>
  <section class="project-recent">
    <h3>Derniers signalements</h3>
    <div class="project-recent__body">
      <div :class="{ active: loading }" class="ui inverted dimmer">
        <div class="ui text loader">
          Récupération des signalements en cours...
        </div>
      </div>
      <div class="ui relaxed list">
        <div
          v-for="(item, index) in features.slice(0, 5)"
          :key="item.properties.title + index"
          class="item"
        >
          <div class="content">
            <div>
              <FeatureFetchOffsetRoute
                :feature-id="item.id"
                :properties="item.properties"
              />
            </div>
            <div class="description">
              <em
                >[ {{ item.properties.created_on | formatDate
                }}<span v-if="user && item.properties.display_creator"
                  >, par {{ item.properties.display_creator }} </span
                >]</em
              >
            </div>
          </div>
        </div>
        <p
          v-if="features.length === 0 && !loading"
          class="project-recent__empty"
        >
          Pas de nouveaux signalements
        </p>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";
import FeatureFetchOffsetRoute from "@/components/Feature/FeatureFetchOffsetRoute";

import { formatStringDate } from "@/utils";

export default {
  name: "ProjectLastFeatures",

  filters: {
    formatDate(value) {
      return formatStringDate(value);
    },
  },

  components: {
    FeatureFetchOffsetRoute,
  },

  data() {
    return {
      loading: true,
    };
  },

  computed: {
    ...mapState("feature", ["features"]),
    ...mapState(["user"]),
  },

  mounted() {
    this.fetchLastFeatures();
  },

  methods: {
    fetchLastFeatures() {
      this.loading = true;
      this.$store
        .dispatch("feature/GET_PROJECT_FEATURES", {
          project_slug: this.$route.params.slug,
          ordering: "-created_on",
          limit: 5,
        })
        .then(() => {
          this.loading = false;
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
.project-recent {
  flex: 0 1 auto;
  min-width: 0;
  max-width: 46%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  h3 {
    margin: 0 0 0.65rem;
    color: #1b2142;
    font-size: 1rem;
    font-weight: 700;
  }
}

.project-recent__body {
  position: relative;
  min-height: 2.5rem;
}

.project-recent__empty {
  margin: 0;
  color: #6b7280;
  font-style: italic;
}

.ui.relaxed.list {
  text-align: center;
}
</style>
